const MAX_PX = 20

export const maxRingThicknessPlugin = {
    id: "maxRingThickness",
    afterLayout(chart) {
        const {top, bottom, left, right} = chart.chartArea
        const radius = Math.min(right - left, bottom - top) / 2
        const visibleCount = chart.data.datasets.filter(
            (_, i) => !chart.getDatasetMeta(i).hidden,
        ).length
        const ringSpace = visibleCount * MAX_PX
        const newCutout =
            ringSpace < radius ? `${(((radius - ringSpace) / radius) * 100).toFixed(2)}%` : "0%"
        if (chart.options.cutout !== newCutout) {
            chart.options.cutout = newCutout
            setTimeout(() => chart.update("none"), 0)
        }
    },
}
